import { render } from "./callIcon.vue?vue&type=template&id=694e9f32&lang=true"
import script from "./callIcon.vue?vue&type=script&lang=js"
export * from "./callIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__